//AdminBillingProviderPage.jsx

import React, { useEffect, useState } from "react";

export default function AdminBillingProviderPage() {
    const [provider, setProvider] = useState("CREEM");
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const token = localStorage.getItem("custor.auth.token");

    useEffect(() => {
        async function loadProvider() {
            try {
                const response = await fetch("/admin/billing-provider", {
                    headers: { Authorization: `Bearer ${token}` }
                });

                const data = await response.json();

                if (!response.ok) {
                    throw new Error(data.message || "Unable to load provider");
                }

                setProvider(data.provider);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        }

        if (!token) {
            setError("Please log in again.");
            setLoading(false);
            return;
        }

        loadProvider();
    }, [token]);

    async function saveProvider() {
        setSaving(true);
        setError("");
        setMessage("");

        try {
            const response = await fetch("/admin/billing-provider", {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({ provider })
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || "Unable to change provider");
            }

            setProvider(data.provider);
            setMessage(`Active provider changed to ${data.provider}.`);
        } catch (err) {
            setError(err.message);
        } finally {
            setSaving(false);
        }
    }

    if (loading) return <p>Loading billing settings...</p>;

    return (
        <div className="custor-welcome" style={{ maxWidth: 700, margin: "0 auto" }}>
            <h1>Billing provider</h1>
            <p>Choose the provider used for new checkout sessions.</p>

            <label>
                <input
                    type="radio"
                    name="provider"
                    value="CREEM"
                    checked={provider === "CREEM"}
                    onChange={() => setProvider("CREEM")}
                />
                {" "}Creem (primary)
            </label>

            <br />

            <label>
                <input
                    type="radio"
                    name="provider"
                    value="PADDLE"
                    checked={provider === "PADDLE"}
                    onChange={() => setProvider("PADDLE")}
                />
                {" "}Paddle (backup)
            </label>

            <div style={{ marginTop: 20 }}>
                <button onClick={saveProvider} disabled={saving}>
                    {saving ? "Saving..." : "Save provider"}
                </button>
            </div>

            {message && <p>{message}</p>}
            {error && <div className="custor-error"><p>{error}</p></div>}
        </div>
    );
}